export * from './queryKeys'

export const DEFAULT_FOLDER_NAME = 'Default folder'
